export default {"src":"/_next/static/media/tuhh.9a885f75.svg","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};